import { InputWrapper } from '@mantine/core';

export default InputWrapper.extend({
  styles: (theme) => ({
    label: {
      color: theme.colors.gray[7],
      fontWeight: 500,
      fontSize: theme.fontSizes.sm,
      paddingBottom: theme.spacing.sm,
    },
    error: {
      color: theme.colors.red[5],
    },
    required: {
      color: theme.colors.red[5],
    },
  }),
});
